module.exports = __webpack_public_path__ + "static/img/topcuscontent.b5bedf62.png";